import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setProdactActive, setSelectTabProdact } from '../../EquipmentMineSlice';

const Tabs = ({ indexProdact,setProdactActive, setSelectTabProdact, equipmentsInternet , equipmentsTv }) => {

    const clickTab = (i, item) => {
        setProdactActive(i);
        const filteredProducts = item === 'אינטרנט' ? equipmentsInternet : equipmentsTv;
        setSelectTabProdact(filteredProducts);
    };

    return (
        <div className="wrapper-tabs-prodacts">
            <div className="container-tabs">
                <div className="wrapper-tabs">
                    {['אינטרנט', 'טלויזיה'].map((item, i) => (
                        <button
                            className={`value-tab ${indexProdact === i ? 'value-active' : ''}`}
                            key={i}
                            onClick={() => clickTab(i, item)}
                        >
                            {item}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    indexProdact: state.equipmentMinePage.indexProdact,
    equipmentsTv: state.equipmentMinePage.equipmentsTv,
    equipmentsInternet: state.equipmentMinePage.equipmentsInternet
});

const mapDispatchToProps = {
    setProdactActive,
    setSelectTabProdact,
};

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
